import React from "react";
import PropTypes from "prop-types";

import { Loader } from "../..";

const WithLoader = ({ isLoading, children, className, noChildren, type }) => {
  return (
    <div>
      {isLoading ? (
        <div className={className}>
          <Loader type={type} height="100px" width="100px" />
        </div>
      ) : null}
      <div className={isLoading ? "hidden" : ""} style={{ height: "85%" }}>
        {children}
      </div>
    </div>
  );
};

WithLoader.propTypes = {
  isLoading: PropTypes.bool,
  type: PropTypes.string
};

WithLoader.defaultProps = {
  isLoading: true,
  type: "spinningBubbles"
};

export default WithLoader;
